import initialState from './initial.state';
import * as types from '../actions/types.action';
import {stampSearchId} from '../helpers/data.helper';

export default function upsellingReducer(
  state = initialState.upsellingItems,
  action
) {
  switch (action.type) {
    case types.GET_UPSELLING_ITEMS_REQUESTED:
    case types.GET_UPSELLING_ITEMS_FAILED:
      return Object.assign({}, state, {
        targetedItems: [],
        forgottenItems: [],
        seeThoseDeals: [],
        flashSales: [],
      });
    case types.GET_UPSELLING_ITEMS_SUCCESS:
      const {
        haveYouForgottenTheseItems,
        didYouSeeTheseDeals,
        flashSales,
      } = action.upsellingItems;
      // Each of the three carousels is its own search with its own searchId - keep them apart, or
      // their conversions cannot be told from one another in reporting.
      return {
        forgottenItems: stampSearchId(
          haveYouForgottenTheseItems.results,
          haveYouForgottenTheseItems.searchId
        ),
        seeThoseDeals: stampSearchId(
          didYouSeeTheseDeals.results,
          didYouSeeTheseDeals.searchId
        ),
        flashSales: stampSearchId(flashSales.results, flashSales.searchId),
      };
    default:
      return state;
  }
}
